import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  margin-bottom: 6px;
  font-size: 14px;
  line-height: 1.5;
  color: ${Colors.GS600};
`
